function myCartSection() {
    if($('#shopify-section-header').hasClass('shopify-section-header-sticky')){
      var header_height = $('#shopify-section-header').height();
    }else{
      var header_height = $('#shopify-section-header').height() + $('#shopify-section-announcement-bar').height();
    }
    var SideContentHeight = $('.block-cart-header').innerHeight() + $('.wrapper-cart-drawer__footer').innerHeight();
    $('.wrapper-cart-drawer__items .cart-middle-items').css('height', $(window).height() - SideContentHeight + 'px');
}
$(window).on('load resize scroll',function () {
    if($('#shopify-section-header').hasClass('shopify-section-header-sticky')){
      var header_height = $('#shopify-section-header').height() + 'px';
    }else{
      var header_height = $('#shopify-section-header').height() + $('#shopify-section-announcement-bar').height() + 'px';
    }
    // $('.cart-sidebar').css('height','calc(100% - '+header_height+')');
    myCartSection();
});

function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });
    
    document.querySelectorAll('.header__icon--cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');        
      });
    });
    window.addEventListener('resize', function(event){
      var docWidth = document.documentElement.clientWidth;      

      if(docWidth < 990) {
        var swiper = new Swiper(".mySwiper", {
          slidesPerView: 2,
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      var cart_total = data.total_price;
      myCartSection();
      if(cart_count > 0){
        var countDiv = document.querySelector('.cart-count-bubble').querySelectorAll('[aria-hidden]')[0];
        var countDivDesktop = document.querySelector('.cart-count-bubble .visually-hidden');
        var totalCount = document.querySelector('.cart-total-count');
        var hasCustomer = document.querySelector('.header_cartCount');
        
        if(countDivDesktop != undefined){
          if(cart_count > 1){
            countDivDesktop.innerHTML = cart_count + ' items';
          }else{
            countDivDesktop.innerHTML = cart_count + ' item';
          }  
        }
        
        if(countDiv != undefined){
          countDiv.innerHTML = cart_count;
        }
        
      }else{
      	var countDiv = document.querySelector('.cart-count-bubble').querySelectorAll('[aria-hidden]')[0];
        var countDivDesktop = document.querySelector('.cart-item-count .visually-hidden');
        if(countDiv != undefined){
          countDiv.innerHTML = 0;
        }
        if(countDivDesktop != undefined){
          countDivDesktop.innerHTML = 0 + ' item';
        }
        if(totalCount != undefined){
          totalCount.innerHTML = 0;
        }
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateQuantity(data_index, data_qty) {
	
  var upId = data_index;
  var upQTY = data_qty;
  updateCartItem(upId, upQTY)	
  
  async function updateCartItem(id, qty) {
    const result = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: qty
      })
    })
    .then((data) => {
      if(data.status === 200){
        load_cart();
        //console.log("Done");
      }else{
        console.log('Cart drawer quantity is not updated.');
      }
    });
  }
}

function custom_addtocart(variantsId) {
  
  //console.log("Clicked");
	//console.log(variantsId);
  var pbTempId = Number(variantsId);
  var pbTempQTY = 1;
  addItem(pbTempId, pbTempQTY)

  async function addItem(variantId, quantity) {
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then((data) => {
      if(data.status === 200){  
        
        load_cart();
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        //console.log("Done");
      }else{
        console.log('cart-drawer error');
      }
    });
  }

}
